<div class="main-container">
  <top-nav-bar [items]="items"></top-nav-bar>
  <router-outlet (activate)="componentAdded($event)"></router-outlet>
</div>
